import { makeStyles } from '@material-ui/core/styles';

export const useLogoutButtonStyles = makeStyles(() => ({
  container: {
    backgroundColor: '#F1F1F1',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    marginTop: 5,
    marginBottom: 5,
  },
}));
